export default __webpack_public_path__ + "static/media/bg7.57863fb1.jpg";